/** Basic sign-in email shape check (non-empty, single @, domain with dot). */
export function isValidSignInEmail(value: string): boolean {
  const v = value.trim();
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
